import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { selectUgcSummary } from 'app/selectors/bibs/UgcSelector';
import ContentNotices from './ContentNotices';

export function ContentNoticesContainer(props) {
  return <ContentNotices {...props} />;
}

ContentNoticesContainer.propTypes = {
  summary: ImmutablePropTypes.map.isRequired
};

const mapStateToProps = state => ({
  summary: selectUgcSummary(state)
});

export default connect(mapStateToProps)(ContentNoticesContainer);
